<template>
    <div>
        <div class="group-head">
            <div class="title"><span class="el-icon-data-analysis"></span> 汇总</div>
        </div>
        <el-row :gutter="15" v-loading="dataLoading" class="rank-box">
            <el-col :sm="8" class="MT15">
                <el-card shadow="never">
                    <div slot="header">
                        乐迷新增
                        <router-link class="color-theme" :to="`/report/fans/newFans?rangeStart=${daterange[0]} 00:00:00&rangeEnd=${daterange[1]} 23:59:59`">查看详情</router-link>
                    </div>
                    <div v-if="data" class="statistics">
                        <div class="item">
                            <el-image class="logo">
                                <div slot="error" class="image-slot">
                                    <span class="el-icon-user"></span>
                                </div>
                            </el-image>
                            <div class="info color-danger">
                                <div class="name">全网</div>
                                <div class="amount">新增：{{ data.allUser || 0}}</div>
                            </div>
                        </div>
                        <div class="item">
                            <img class="logo" src="@/assets/img/dashboard/d-logo1.png"/>
                            <div class="info">
                                <div class="name">秀动</div>
                                <div class="amount">新增：{{data.showStartUser || 0}}</div>
                            </div>
                        </div>
                        <div class="item">
                            <img class="logo" src="@/assets/img/dashboard/d-logo6.png"/>
                            <div class="info">
                                <div class="name">大麦</div>
                                <div class="amount">新增：{{data.daMaiUser || 0}}</div>
                            </div>
                        </div>
                        <div class="item">
                            <img class="logo" src="@/assets/img/dashboard/d-logo2.png"/>
                            <div class="info">
                                <div class="name">网易</div>
                                <div class="amount">新增：{{data.wangyiUser || 0}}</div>
                            </div>
                        </div>
                        <div class="item">
                            <img class="logo" src="@/assets/img/dashboard/d-logo4.png"/>
                            <div class="info">
                                <div class="name">腾讯</div>
                                <div class="amount">新增：{{data.tencentUser || 0}}</div>
                            </div>
                        </div>
                        <div class="item">
                            <el-image class="logo">
                                <div slot="error" class="image-slot">
                                    <span class="el-icon-users"></span>
                                </div>
                            </el-image>
                            <div class="info">
                                <div class="name">其他</div>
                                <div class="amount">新增：{{data.otherUser || 0}}</div>
                            </div>
                        </div>
                    </div>
                </el-card>
            </el-col>
            <el-col :sm="8" class="MT15">
                <el-card shadow="never">
                    <div slot="header">
                        B类新增
                    </div>
                    <div v-if="data" class="statistics">
                        <div class="item">
                            <el-image class="logo">
                                <div slot="error" class="image-slot">
                                    <span class="el-icon-s-custom"></span>
                                </div>
                            </el-image>
                            <div class="info color-danger">
                                <div class="name">全部</div>
                                <div class="amount">新增：{{ data.allBUser || 0}}</div>
                            </div>
                        </div>
                        <router-link class="item" :to="`/user/artist/list?startTime=${daterange[0]} 00:00:00&endTime=${daterange[1]} 23:59:59`">
                            <div class="logo category-logo category-2-logo">
                                <img src="@/assets/img/dashboard/icon_artist.png"/>
                            </div>
                            <div class="info">
                                <div class="name">艺人</div>
                                <div class="amount">新增：{{data.performerUser || 0}}</div>
                            </div>
                        </router-link>
                        <router-link class="item" :to="`/user/site/list?startTime=${daterange[0]} 00:00:00&endTime=${daterange[1]} 23:59:59`">
                            <div class="logo category-logo category-3-logo">
                                <img src="@/assets/img/dashboard/icon_venue.png"/>
                            </div>
                            <div class="info">
                                <div class="name">场地</div>
                                <div class="amount">新增：{{data.siteUser || 0}}</div>
                            </div>
                        </router-link>
                        <router-link class="item" :to="`/user/brand/list?startTime=${daterange[0]} 00:00:00&endTime=${daterange[1]} 23:59:59`">
                            <div class="logo category-logo category-5-logo">
                                <img src="@/assets/img/dashboard/icon_host.png"/>
                            </div>
                            <div class="info">
                                <div class="name">厂牌</div>
                                <div class="amount">新增：{{data.brandUser || 0}}</div>
                            </div>
                        </router-link>
                    </div>
                </el-card>
            </el-col>
            <!-- <el-col :sm="8" class="MT15">
                <el-card shadow="never">
                    <div slot="header">
                        用户活跃
                        <router-link class="color-theme" :to="`/report/fans/loginFans?rangeStart=${daterange[0]} 00:00:00&rangeEnd=${daterange[1]} 23:59:59`">查看详情</router-link>
                    </div>
                    <div v-if="data" class="statistics">
                        <div class="item">
                            <el-image class="logo">
                                <div slot="error" class="image-slot">
                                    <span class="el-icon-s-custom"></span>
                                </div>
                            </el-image>
                            <div class="info color-danger">
                                <div class="name">全网</div>
                                <div class="amount">活跃：{{ data.loginFans.totalNum || 0}}</div>
                            </div>
                        </div>
                        <div class="item">
                            <img class="logo" src="@/assets/img/dashboard/logo_ios.png"/>
                            <div class="info">
                                <div class="name">iOS</div>
                                <div class="amount">活跃：{{data.loginFans.iosNum || 0}}</div>
                            </div>
                        </div>
                        <div class="item">
                            <img class="logo" src="@/assets/img/dashboard/logo_android.png"/>
                            <div class="info">
                                <div class="name">Android</div>
                                <div class="amount">活跃：{{data.loginFans.androidNum || 0}}</div>
                            </div>
                        </div>
                        <div class="item">
                            <img class="logo" src="@/assets/img/dashboard/logo_wapcn.png"/>
                            <div class="info">
                                <div class="name">WAPCN</div>
                                <div class="amount">活跃：{{data.loginFans.wapNum || 0}}</div>
                            </div>
                        </div>
                        <div class="item">
                            <img class="logo" src="@/assets/img/dashboard/d-logo1.png"/>
                            <div class="info">
                                <div class="name">微信小程序</div>
                                <div class="amount">活跃：{{data.loginFans.appletNum || 0}}</div>
                            </div>
                        </div>
                        <div class="item">
                            <img class="logo" src="@/assets/img/dashboard/d-logo1.png"/>
                            <div class="info">
                                <div class="name">抖音小程序</div>
                                <div class="amount">活跃：{{data.loginFans.byteAppletNum || 0}}</div>
                            </div>
                        </div>
                    </div>
                </el-card>
            </el-col> -->
        </el-row>
    </div>
</template>

<script>
export default {
    props:{
        daterange: {
            type: Array,
            default: () => []
        }
    },
    data(){
        return{
            data: null,
            dataLoading: false,
        }
    },
    mounted(){
        this.getData();
    },
    watch:{
        daterange(v1,v2){
            if(v2.length > 0 && v1 != v2){
                this.getData();
            }
        }
    },
    methods: {
        getData(){
            this.dataLoading = true;
            this.$request({
                url: "/dashboard/userRank",
                method: "POST",
                data: {
                    start: this.daterange.length > 0 ? this.daterange[0]: "",
                    end: this.daterange.length > 1 ? this.daterange[1]: "",
                }
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
    }
}
</script>
<style lang="scss" scoped>
.statistics{
    // display: flex;
    // flex-wrap: wrap;
    // justify-content: space-between;
    height: 360px;
    .item{
        // width: 25%;
        // text-align: center;
        display: flex;
        // flex-direction: column;
        align-items: center;
        // background: #f8f8f8;
        padding: 10px 5px;
        .logo{
            width: 40px;
            height: 40px;
            margin-right: 20px;
            ::v-deep .image-slot{
                font-size: 26px;
                background: $--color-danger;
                border-radius: 50%;
                padding: 10px;
                color: #fff;
            }
            &.category-logo{
                border-radius: 50%;
                padding: 10px;
                img{
                    width: 20px;
                    height: 20px;
                }
                &.category-2-logo{
                    background:  rgba(100,150,249,1);
                }
                &.category-3-logo{
                    background: rgba(99,218,171,1);
                }
                &.category-5-logo{
                    background: rgba(102,119,153,1);
                }
            }
        }
        .info{
            flex: 1;
            .name{
                font-size: 14px;
                font-weight: 700;
            }
        }
    }
}
</style>